module.exports = __webpack_public_path__ + "static/media/health-apiled.c3caf768.png";